import AppImage from '@theme/components/atom/AppImage'
import AppTitle from '@theme/components/atom/AppTitle'
import HeadingLevel from '~/mixins/HeadingLevel'

export default {
  mixins: [HeadingLevel],
  components: {
    AppImage,
    AppTitle,
  },
  props: {
    employee: Object,
    imageWidth: {
      type: Number,
      default() {
        return this.$themeSettings.components.EmployeeBox.imageWidth
      },
    },
    imageHeight: {
      type: Number,
      default() {
        return this.$themeSettings.components.EmployeeBox.imageHeight
      },
    },
  },
}
